import React, { useEffect, useState } from 'react';
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  IconButton,
  Stack,
  Typography
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';

interface GroupModalProps {
  showOptionModal: boolean;
  onCancel: () => void;
  onSubmit: (options: string[], columnInfo: any) => void;
  group?: string[];
  columnInfo: any;
}

const GroupModal: React.FC<GroupModalProps> = ({
  showOptionModal,
  onCancel,
  onSubmit,
  group = [],
  columnInfo
}) => {
  const [options, setOptions] = useState<string[]>(['']);

  useEffect(() => {
    if (Array.isArray(group) && group.length > 0) {
      setOptions(group);
    } else {
      setOptions(['']);
    }
  }, [group]);

  const handleInputChange = (value: string, index: number) => {
    const updated = [...options];
    updated[index] = value;
    setOptions(updated);
  };

  const handleRemoveOption = (index: number) => {
    const updated = [...options];
    updated.splice(index, 1);
    setOptions(updated);
  };

  const addOptionRow = () => {
    setOptions(prev => [...prev, '']);
  };

  const handleSubmit = () => {
    const cleaned = options
      .map(opt => (typeof opt === 'string' ? opt.trim() : ''))
      .filter(opt => opt !== '');

    const unique = Array.from(new Set(cleaned));

    const removedGroups = (group || [])
      .map(g => (typeof g === 'string' ? g.trim() : ''))
      .filter(orig => orig && !unique.includes(orig));

    onSubmit(unique, { ...columnInfo, removedGroups });
  };


  return (
    <Dialog open={showOptionModal} onClose={onCancel} fullWidth maxWidth="sm">
      <DialogTitle>
        <Typography variant="h6">Manage Groups</Typography>
        <IconButton
          aria-label="close"
          onClick={onCancel}
          sx={{ position: 'absolute', right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2}>
          {options.map((opt, index) => (
            <Box key={index} display="flex" alignItems="center" gap={2}>
              <TextField
                size="small"
                fullWidth
                label={`Group ${index + 1}`}
                value={opt}
                placeholder="Enter Group Title"
                onChange={(e) => handleInputChange(e.target.value, index)}
              />
              {/* {options.length > 1 && ( */}
              <IconButton aria-label="remove" onClick={() => handleRemoveOption(index)}>
                <CloseIcon />
              </IconButton>
              {/* )} */}
              {index === options.length - 1 && (
                <IconButton aria-label="add" onClick={addOptionRow}>
                  <AddIcon />
                </IconButton>
              )}
            </Box>
          ))}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" size="small" onClick={handleSubmit}>
          Submit
        </Button>
        <Button onClick={onCancel} size="small">Cancel</Button>
      </DialogActions>
    </Dialog>
  );
};

export default GroupModal;
